(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    observer = undefined;

    constructor() {
      super();
    }

    connectedCallback() {
      this.initializeRecommendations(this.dataset.productId);
    }

    initializeRecommendations(productId) {
      this.observer?.unobserve(this);
      this.observer = new IntersectionObserver(
        (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);
          this.loadRecommendations(productId);
        },
        { rootMargin: '0px 0px 400px 0px' }
      );
      this.observer.observe(this);
    }

    loadRecommendations(productId) {
      fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations?.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            this.initalizeSwiperSlider();
          } else {
            if (this.classList.contains('complementary-products')) {
              document.querySelector('.complementary-products').remove();
            } else {
              this.closest('.related-product-section').remove();
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }

    initalizeSwiperSlider() {
      //------------ Also Like Carousel [PDP Page] ------------
      if (document.querySelector('.also-like-carousel')) {
        const alsoLike = document.querySelector('.also-like-carousel');
        const slideCount = alsoLike.querySelectorAll('.swiper-slide').length;
        let mySwiper;
        const slidesToShow = 4;

        if (!alsoLike.classList.contains("swiper-initialized")) {
          mySwiper = new Swiper('.also-like-carousel', {
            loop: true,
            spaceBetween: 0,
            slidesPerView: 4,
            breakpoints: {
              992: { slidesPerView: 4 },
              641: { slidesPerView: 3 },
              320: { slidesPerView: 2 },
            },
          });
        }
        if (window.innerWidth < 768) {
          if (!alsoLike.classList.contains("swiper-initialized")) {
            mySwiper = new Swiper('.also-like-carousel');
          }
        } else {
          if (slideCount >= slidesToShow) {
            if (!alsoLike.classList.contains("swiper-initialized")) {
              mySwiper = new Swiper('.also-like-carousel');
            }
          } else {
            if (alsoLike.classList.contains("swiper-initialized")) {
              mySwiper.destroy(true, true);
              mySwiper = undefined;
            }
          }
        }
      }

      //------------ Free Shipping Carousel [PDP Page] ------------
      if(document.querySelector('.free-shipping-carousel')){
        var free_shipping_carousel = new Swiper('.free-shipping-carousel', {
          loop: false,
          spaceBetween: 8,
          slidesPerView: 2,
          navigation: {
            nextEl: '.free-shipping-carousel-wrapper .swiper-button-next',
            prevEl: '.free-shipping-carousel-wrapper .swiper-button-prev',
          },
          breakpoints: {
            1281: {
              slidesPerView: 2,
            },
            1141: {
              slidesPerView: 1.5,
            },
            851: {
              slidesPerView: 1.2,
            },
            769: {
              slidesPerView: 2,
            },
            576: {
              slidesPerView: 1.5,
            },
            320: {
              slidesPerView: 1,
            },
          },
        });
      }
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  /* Product variant */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.abortController = null;
    }

    connectedCallback() {
      this.productUrl = this.dataset.productUrl;
      this.sectionId = this.dataset.section;
      this.changeURL = this.dataset.changeUrl === 'true';
      this.addButton = document.querySelector(`#product-form-${this.sectionId} [name="add"]`);
      this.inputField = document.querySelector(`#product-form-${this.sectionId} [name="id"]`);

      this.addEventListener('change', (event) => {
        const optionValues = this.selectedOptionValues.join(',');
        const requestUrl = `${this.productUrl}?section_id=${this.sectionId}&option_values=${optionValues}`;
        this.renderProductInfo(requestUrl, this.productUrl, this.sectionId, this.changeURL);
      });

      // this.addBtnText(true, '', this.addButton);
    }

    get selectedOptionValues() {
      return Array.from(this.querySelectorAll('.swatch-block input:checked')).map(
        ({ dataset }) => dataset.optionValueId
      );
    }

    async renderProductInfo(requestUrl, productUrl, sectionId, changeURL) {
      if (this.abortController) {
        this.abortController.abort();
      }

      this.abortController = new AbortController();
      this.addButton.disabled = true;

      try {
        const response = await fetch(requestUrl, {
          signal: this.abortController.signal,
        });
        const responseText = await response.text();
        const html = new DOMParser().parseFromString(responseText, 'text/html');

        const variantElement = html.querySelector('variant-selects [data-selected-variant]');
        const variantData = variantElement ? variantElement.textContent : null;
        const variant = variantData ? JSON.parse(variantData) : null;
        // console.log('variant', variant);

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId: this.sectionId,
            html,
            variant,
          },
        });
        
        if (!variant) {
          this.addBtnText(true, window.variantStrings.unavailable, this.addButton);
          return;
        }
        this.inputField.value = variant.id;
        this.addBtnText(!variant.available, window.variantStrings.soldOut, this.addButton);

        if (changeURL) {
          const newUrl = `${productUrl}${variant ? `?variant=${variant.id}` : ''}`;
          window.history.replaceState({}, '', newUrl);
        }

        this.replaceContent(['price','quantity'], sectionId, html);
      } catch (error) {
        if (error.name === 'AbortError') {
          return;
        }
        console.error('Error in renderProductInfo:', error);
      }
    }

    addBtnText(disable, text, btnElement) {
      if (!btnElement) return;

      btnElement.disabled = disable;

      const span = btnElement.querySelector('span');
      if (!span) return;

      if (disable) {
        if (text) {
          span.textContent = text;
        }
      } else {
        span.textContent = window.variantStrings.addToCart;
      }
    }

    replaceContent(selectors, sectionId, html) {
      selectors.forEach((selector) => {
        const targetSelector = `[data-${selector}-${sectionId}]`;
        const target = document.querySelector(targetSelector);
        const source = html.querySelector(targetSelector);
        if (target && source) {
          target.innerHTML = source.innerHTML;
          if (selector === 'quantity') {
            target.connectedCallback();
          }
        }
      });
    }
  }

  customElements.define('variant-selects', VariantSelects);

  } catch(e) { console.error(e); }
})();
})();
